import { useContext } from 'react'

import {
  Button, Form, ModalContext, SidebarModal,
} from '@domain-group/suit-theme'

import useCreateBrandCustomProfile from './hooks/useCreateBrandCustomProfile'

const MODAL_KEY = 'CreateOrEditBrandCustomProfileModal'

type ModalCallbacks = {
  closeModal: () => void,
}

type ModalProps = {
  callbacks: ModalCallbacks,
  showModal: boolean,
}

const CreateOrEditBrandCustomProfileModal = (props: ModalProps) => {
  const { callbacks, showModal } = props

  const modalContext = useContext(ModalContext)
  const { modalData } = modalContext

  const modalPayload = modalData?.[MODAL_KEY] ?? {}
  const { brandCustomProfile: initBrandCustomProfile } = modalPayload

  const {
    brandCustomProfileFormPayload,
    callbacks: { manageBrandCustomProfileUserPermissions },
    entityState,
    filteredRoles,
    handlers,
    saveEnabled,
  } = useCreateBrandCustomProfile(initBrandCustomProfile)

  const {
    role_id: roleId, title, profile_type: profileType,
  } = entityState || {}

  return (
    <SidebarModal callbacks={callbacks} clickSafeZone modalKey={MODAL_KEY} showModal={showModal}>
      <SidebarModal.Header callbacks={callbacks} title="Create" titleSecondLine="Profile" />

      <SidebarModal.Content>
        <Form>
          <Form.Field label="* Role">
            {/*
           // @ts-expect-error TS2322 */}
            <select name="role_id" value={roleId} disabled={!!initBrandCustomProfile.id} {...handlers}>
              <option value="">Please Select...</option>
              {filteredRoles?.map(role => (
                <option key={role.id} value={role.id}>
                  {role.title}
                </option>
              ))}
            </select>
          </Form.Field>

          <Form.Field label="* Role Custom Title" marginTop="large">
            <input name="title" type="text" value={title} {...handlers} />
          </Form.Field>

          <Form.Field label="* Settings Type" marginTop="large">
            {/*
           // @ts-expect-error TS2322 */}
            <select name="profile_type" value={profileType} {...handlers} disabled={!!initBrandCustomProfile.id}>
              <option value="">Please Select...</option>
              <option value="agency_marketing">Agency Marketing</option>
              <option value="property_marketing">Property Marketing</option>
              <option value="notifications">Notification Options</option>
            </select>
          </Form.Field>
        </Form>
      </SidebarModal.Content>

      <SidebarModal.Footer>
        <Button
          buttonStyle="primaryCreate"
          disabled={!saveEnabled}
          onClick={() => manageBrandCustomProfileUserPermissions(brandCustomProfileFormPayload, roleId)}
          size="large"
        >
          Select Permissions
        </Button>
      </SidebarModal.Footer>
    </SidebarModal>
  )
}

const LazyLoadedModal = (props: ModalProps) => (
  <SidebarModal.RenderController {...props}>
    <CreateOrEditBrandCustomProfileModal {...props} />
  </SidebarModal.RenderController>
)

export default LazyLoadedModal
